import {useDrag} from '@use-gesture/react';
import {useState} from 'react';

const SWIPE_THRESHOLD = 60;
const MAX_SWIPE_OFFSET = 40;
const RUBBER_BAND_FACTOR = 0.3;

interface SwipeToReattachResult {
  bind: (...args: unknown[]) => Record<string, unknown>;
  swipeOffset: number;
}

function clampWithRubberBand(offset: number): number {
  const sign = Math.sign(offset);
  const abs = Math.abs(offset);

  if (abs <= MAX_SWIPE_OFFSET) {
    return offset;
  }

  const overscroll = abs - MAX_SWIPE_OFFSET;
  return sign * (MAX_SWIPE_OFFSET + overscroll * RUBBER_BAND_FACTOR);
}

export function useSwipeToReattach(onReattach: VoidFunction | undefined, enabled: boolean): SwipeToReattachResult {
  const [swipeOffset, setSwipeOffset] = useState(0);

  const bind = useDrag(
    ({active, movement: [mx], last}) => {
      if (!enabled) {
        return;
      }

      if (active) {
        setSwipeOffset(clampWithRubberBand(mx));
      }

      if (last) {
        if (Math.abs(mx) > SWIPE_THRESHOLD) {
          onReattach?.();
        }
        setSwipeOffset(0);
      }
    },
    {
      axis: 'x',
      filterTaps: true,
    }
  );

  return {bind, swipeOffset: enabled ? swipeOffset : 0};
}
